import Swiper from 'swiper';

export const initTestimonialCarousel = () => {
  document.addEventListener('DOMContentLoaded', function () {
    let swiper = new Swiper('.review_carousel__container', {
      slidesPerView: 'auto',
      spaceBetween: 152,
      centeredSlides: true,
      touchEventsTarget: 'container',
      on: {
        afterInit: function () {
          let reviewWrappers = document.querySelectorAll('.review_carousel__wrapper');
          reviewWrappers.forEach((reviewWrapper) => {
            reviewWrapper.classList.remove('gap-[152px]');
          });
        },
      },
    });

    const reviewCarouselSection = document.querySelector('.review_carousel');
    if (reviewCarouselSection) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              swiper.slideTo(1, 600);
              observer.unobserve(reviewCarouselSection);
            }
          });
        },
        { threshold: 0.5 },
      );

      observer.observe(reviewCarouselSection);
    }
  });
};
